import { getSourceSelectOptions } from 'app/sponsoredAds/services/servicesSponsoredAds';
import apiDataResponseHandler from 'util/promiseFactory/apiDataResponseHandler';
import withInputErrorMessage from '../withInputErrorMessage';
import remoteOptionSelectFactory from './remoteOptionSelectFactory';
import withSelectFormik from './withSelectFormik';
import withSelectPills from './withSelectPills';

const SourceSelectSA = remoteOptionSelectFactory({
   getSuggestionsPromise: getSourceSelectOptions,
   handleApiDataResponse: apiDataResponseHandler.withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel,
});

export default withSelectFormik(withInputErrorMessage(SourceSelectSA));
export const SourceSelectPillsSA = withSelectPills(SourceSelectSA);
